import React, { useState } from 'react'
import CreateGlobalTemplate from '../../../components/GlobalTemplate/CreateGlobalTemplate'
import EditGlobalTemplate from '../../../components/GlobalTemplate/EditGlobalTemplate'
import ManageGlobalTemplates from '../../../components/GlobalTemplate/ManageGlobalTemplates'
import { Navigate, Route, Routes } from 'react-router-dom'
import { GlobalTemplateContext } from '../../../contexts/GlobalTemplateContext'
import { deleteTemplateById, getAllTemplateData } from '../../../utils/APIs'
import { useUserContext } from '../../../contexts/UserContext'

const GlobalTemplate = () => {
      const { userData } = useUserContext();
      const [data, setData] = useState([]);
      const [rawData, setRawData] = useState([]);
      const [loading, setLoading] = useState(false);
      const [selectedTemplateId, setSelectedTemplateId] = useState('');
      const [isGlobalTemplates, setIsGlobalTemplates] = useState(false);

    
      const deleteTemplate = async (id) => {
        try {
          setLoading(true);
          const result = await deleteTemplateById(
            userData?.token,
            userData?.selectedOrganization?.org_token,
            id,
            'global'
          );
          if (result.status) {
            const result = await getAllTemplateData(
              userData?.token,
              userData?.selectedOrganization?.org_token,
              {scope:'global'}
            );
    
            setRawData(result.data);
          }
        } catch (error) {
          console.log('error', error)
        } finally {
          setLoading(false);
        }
      }

      const getExperienceJSON = (base_config_json) => {
        const experience_json = {};
        base_config_json.forEach(function (item) {
          experience_json[item.id] = item.default_value;
        })
        return experience_json;
      }
    
      const getTemplatesRawData = async () => {
        try {
          setLoading(true);
          const result = await getAllTemplateData(
            userData?.token,
            userData?.selectedOrganization?.org_token,
            {scope:'global'}
          );
    
          setRawData(result.data);

          const formattedData = {}
          result.data.forEach((item) => {
            if (item?.html && item?.css && item?.json)
              formattedData[item.name] = {
                name: item.name,
                code: {
                  html: `function(template) { return \`${item?.html}\` }`,
                  styles: item?.css,
                },
                base_config_json: JSON.parse(`${item?.json}`),
                experience_json: getExperienceJSON(JSON.parse(`${item?.json}`)),
              };
          });
    
          setData((prev) => ({ ...formattedData, ...prev }))
        } catch (error) {
          console.log('error', error)
        } finally {
          setLoading(false);
        }
      };

    return (
        <div className="w-full">
            <GlobalTemplateContext.Provider value={{data, setData, rawData, setRawData, getTemplatesRawData, loading, setLoading, selectedTemplateId, setSelectedTemplateId, isGlobalTemplates, setIsGlobalTemplates, deleteTemplate  }}>
                <Routes>
                    <Route path="/create-global-template" element={<CreateGlobalTemplate />} />
                    <Route path="/edit-global-template/:id?" element={<EditGlobalTemplate />} />
                    <Route path="/manage-global-templates" element={<ManageGlobalTemplates />} />
                    <Route path="*" element={<Navigate to="/dashboard" replace={true} />} />
                </Routes>
            </GlobalTemplateContext.Provider>
        </div>
    )
}

export default GlobalTemplate
